import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Text, toFlexItemClassName } from '@dossierhq/design';
import { useMemo } from 'react';
import { RichTextEditor } from '../RichTextEditor/RichTextEditor.js';
export function RichTextFieldEditor({ fieldSpec, adminOnly, value, validationIssues, dragHandle, onChange, }) {
    //TODO validation issues in components in the rich text are shown both here and in the component editor
    //TODO would be good to show the validation issues in context in the rich text editor
    const uniqueValidationIssues = useMemo(() => {
        const messages = new Set(validationIssues.map((error) => error.message));
        return [...messages];
    }, [validationIssues]);
    return (_jsxs(_Fragment, { children: [dragHandle, _jsx(RichTextEditor, { fieldSpec: fieldSpec, adminOnly: adminOnly, value: value, onChange: onChange }), uniqueValidationIssues.map((message, index) => (_jsx(Text, { textStyle: "body2", marginTop: 1, color: "danger", children: message }, index)))] }));
}
export function AddRichTextListItemButton({ onAddItem, }) {
    return (_jsx(Button, { className: toFlexItemClassName({ alignSelf: 'flex-start' }), onClick: () => onAddItem(null), children: "Add" }));
}
//# sourceMappingURL=RichTextFieldEditor.js.map